export default __webpack_public_path__ + "static/media/five-stages.ee7986f2.svg";